var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#FF9811;}\n\t.st2{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,437C-25,337-25,175,75,75S337-25,437,75c0,0,68,230.1-32,330C305,505,75.1,437.1,75,437L75,437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,437c100,100,262.1,100,362,0S537,175,437,75L75,437z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400.8,144.7v-44.5h-85.3l-6.5,6.5c-23.2,23.2-19.3,50.2-16.4,70c2.6,18.3,3,25.3-3.9,32.2 c-6.8,6.8-13.8,6.5-32.2,3.9c-19.8-2.8-46.8-6.7-70,16.4c-23.2,23.2-19.3,50.2-16.4,70c2.6,18.3,3,25.3-3.9,32.2 c-6.8,6.8-13.8,6.5-32.2,3.9c-7.1-1-14.5-2.1-22.4-2.2l-0.5,44.5c4.9,0.1,10.6,0.9,16.5,1.7c7.1,1,15.1,2.2,23.5,2.2 c8.7,0,17.9-1.2,27-5.2v35.6H245v-33.4h-33.4v-22.3h22.3v-33.4h-17.8c0.8-10.8-0.6-21.1-1.9-30c-2.6-18.3-3-25.3,3.9-32.1 c6.8-6.8,13.8-6.5,32.2-3.9c14.4,2.1,32.7,4.7,50.5-3v35.6h66.8V256H334v-22.3h22.3v-33.4h-17.8c0.8-10.8-0.6-21.1-1.9-30 c-1.8-12.8-2.6-20.1-0.5-25.6L400.8,144.7L400.8,144.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBt);
export default __webpack_public_path__ + "static/media/bt.41a7cc3a8261cedba33d240535b71af3.svg";
export { ForwardRef as ReactComponent };